<template>
  <header class="main-header">
    <nav class="navbar-organisation">
      <router-link :to="{ name: 'events-overview' }" class="logo">
        <img v-if="currentOrg" :src="`${BASE_PATH}images/logo.svg`" :alt="`${currentOrgName}`" />
      </router-link>
      <NavbarMain class="navbar-main" />
      <div class="navbar-user">
        <UserAction v-if="user" />
      </div>
    </nav>
    <NavbarEvent v-if="event && !$route.meta.isCreating" :event="event" class="navbar-event" />
    <GAlert :show="isInvited" dismissible variant="success" class="alert">
      {{
        $t('views.invite.accept.inviteAccepted', {
          org: $route.params.organization_name,
        })
      }}
    </GAlert>
  </header>
</template>

<script>
  import NavbarMain from '@/components/navigation/NavbarMain.vue';
  import NavbarEvent from '@/components/navigation/NavbarEvent.vue';
  import { defineAsyncComponent, defineComponent } from 'vue';

  export default defineComponent({
    components: {
      UserAction: defineAsyncComponent(() => import('@/components/navigation/UserAction.vue')),
      NavbarMain,
      NavbarEvent,
    },
    data() {
      return {
        BASE_PATH: process.env.VITE_APP_BASE_PATH || '/',
      };
    },
    computed: {
      event() {
        return this.$store.state.Events.current_event;
      },
      user() {
        return this.$store.state.Account.self;
      },
      currentOrg() {
        return this.$store.state.Organizations.current_organization;
      },
      currentOrgName() {
        return this.$store.state.Organizations.current_organization.name;
      },
      isInvited() {
        return !!this.$route.params.invite;
      },
    },
  });
</script>

<style lang="scss" scoped>
  .logo {
    display: none;
    opacity: 0.9;

    @media (min-width: $tablet) {
      display: block;
      flex-shrink: 0;
      width: 40px;
      height: 40px;
      margin: 0.25rem 1rem 0.25rem 0;
    }

    &:hover {
      opacity: 1;
    }

    &:hover,
    &:focus,
    &:active {
      border: none;
      outline: none;
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  .navbar-organisation {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0.25rem 0.5rem 0.25rem 1rem;
    background-color: $color-gray-900;
  }

  .navbar-main {
    flex: 1;
    margin-right: 0.5rem;
  }

  .navbar-user {
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>
